import classes from "./FinalMark.module.css"
import "@fontsource/roboto"
import InputBlock from "components/UI/inputBlock/InputBlock"
import { useState, useRef, useEffect, useMemo } from 'react'
import Tooltip from "rc-tooltip"
import 'rc-tooltip/assets/bootstrap_white.css';
import PackMarkButton from "components/UI/circleButtonMark/packMarkButton/PackMarkButton"
import { useDeviceType } from "components/hooks/useDeviceType"
import Description from "components/UI/description/Description"
import Loader from "components/UI/loader/Loader"
import Strings from "values/Strings"
import { NotificationManager } from "react-notifications"
import CommandService from "services/CommandService"
import RatingJuryService from "services/JuryService"
import { useFetching } from "components/hooks/useFetching"
import Button from "components/UI/buttons/button/Button"
import Table from "rc-table"
import CheckMarkBlock from "../checkMarkBlock/CheckMarkBlock"
import OAuthService from "services/OAuthService"
import OccasionService from "services/OccasionService"
import { useDispatch } from "react-redux"
import { changeLoaderStatus } from "redux/slice/loaderSlice"
import TableForMark from "components/UI/tableForMark/TableForMark"
import AcordionForGrade from "components/UI/acordionForGrade/AcordionForGrade"
import CheckPointService from "services/CheckService"
import TeamChoice from "components/UI/teamChoice/TeamChoice"
import TeamChoiceButton from "../teamChoiceButton/TeamChoiceButton"
import TitleMain from "components/UI/titleMain/TitleMain";

const FinalMark = ({ onClick }) => {
    const ref = useRef()
    const [grades, setGrades] = useState({})
    const device = useDeviceType()


    const [command, setCommand] = useState([])
    const [commandListPhone, setCommandListPhone] = useState([])
    const [commandList, setCommandList] = useState([])
    const [currentCommand, setCurrentCommand] = useState('')
    const [currentCommandId, setCurrentCommandId] = useState(-1)
    const [comment, setComment] = useState('')
    const [isSaved, setIsSaved] = useState(false)
    const [tableData, setTableData] = useState([])
    const [tableTitle, setTableTitle] = useState([])
    const [titlesData, setTitlesData] = useState([])
    const [codeInfo, setCodeInfo] = useState({})

    const notificationError = (error) => {
        if (error?.message.length > 0) {
            NotificationManager.error(`${error?.message}`, Strings.notificationsErrorTitle, 5000);
        }
    }

    const [featchingTitalRatingJury, loadingTitalRatingJury, errorTitalRatingJury] = useFetching(async () => {
        try {
            const res = await RatingJuryService.getFinalMark()
            res && setTableData(res.map((item, i) => ({ name: item.name, grade: item.grade, ...item.grades, key: i })))
        } catch (error) {
            notificationError(error)
        }
    })


    const [fetchingCommands, loadingCommands, errorCommands] = useFetching(async () => {
        try {
            const res = await CommandService.getCurrentRatingJury()
            device === 'phone'
                ? setCommandListPhone(res)
                : setCommandList(CommandService.getCurrentCommandsNamesForListDescktop(res))
            setCommand(res)
        } catch (error) {
            notificationError(error)
        }
    })

    const [fetchingGradesForCommands, loadingGradesCommands, errorGradesCommands] = useFetching(async (command, num) => {
        try {
            const data = `command=${command}`
            const res = await RatingJuryService.getGradesCurrentCommands(data)
            if (res.grades) {
                setGrades(res.grades)
            }
            if (res.comment) {
                setComment(res.comment)
            }
        } catch (error) {
            notificationError(error)
        }
    })

    const [createOrUpdateRatingJuryCommand, loadingCreateOrUpdateRatingJury, errorCreateOrUpdateRatingJury] = useFetching(async () => {
        try {
            device === 'phone' && setCommandListPhone(old => {
                const getCurrentElementId = old.findIndex(item => item.command_id === currentCommandId)
                old[getCurrentElementId].grades = grades
                return old
            })
            const grade = await RatingJuryService.juryGradeSum(grades)
            const res = await RatingJuryService.createOrUpdateRatingJuryCommand({ comment, grade, grades, command: currentCommandId })
            setIsSaved(true)
            res && NotificationManager.success(Strings.notificationsDataUpdate, Strings.notificationsSuccessTitle, 2500)
            featchingTitalRatingJury()
        } catch (error) {
            notificationError(error)
        }
    })

    const clear = () => {
        setGrades({})
        setComment('')
        setIsSaved(false)
    }

    const dispatch = useDispatch()
    const [occasion, setOccasion] = useState(null)
    const [getCurrentOccasion, loadingCurrentOccasion, errorCurrentOccasion] = useFetching(async () => {
        try {
            const { part } = OAuthService.decryptedSync('userData')
            const res = await OccasionService.getOccasionById(part?.occasion_id)
            setOccasion(res)

            const tableTitleData = JSON.parse(res.final_assessment_question).map(item => item.name)
            setTitlesData(tableTitleData)

            setTableTitle([
                {
                    title: 'Команда',
                    dataIndex: 'name',
                    key: 'name',
                },
                ...(device === 'desktop')
                    ? tableTitleData.map((item, i) => ({
                        title: item,
                        dataIndex: `m${i + 1}`,
                        key: `m${i + 1}`,
                    }))
                    : tableTitleData.map((item, i) => ({
                        title: i + 1,
                        dataIndex: `m${i + 1}`,
                        key: `m${i + 1}`,
                    }))
                ,
                {
                    title: 'Итоговая',
                    dataIndex: 'grade',
                    key: 'grade',
                }
            ])
            dispatch(changeLoaderStatus(false))
        } catch (error) {
            notificationError(error)
        }
    })


    useEffect(() => {
        getCurrentOccasion()
        fetchingCommands()
        featchingTitalRatingJury()
    }, [])


    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
    };

    useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnload)
        return () => window.removeEventListener('beforeunload', handleBeforeUnload)
    }, [grades])

    const choiceCommand = (_, i) => {
        setPopUpWindowForChoice(false)
        clear()
        fetchingProfileMentor(command[i]?.command_id)
        setCurrentCommandId(command[i]?.command_id)
        fetchingCodeData(command[i]?.command_id)
        setCurrentCommand(commandList.length > 0 ? commandList[i] : commandListPhone[i])
        fetchingGradesForCommands(command[i]?.command_id)
    }

    // -----------------------------------------Acordion

    const notificationWarning = (error) => {
        if (error.length > 0) {
            NotificationManager.warning(error, Strings.notificationsWarningTitle, 5000);
        }
    }

    const [fetchingCodeData, loadingCodeData, errorCodeData] = useFetching(async (id) => {
        try {
            const res = await CommandService.getCommandInfo(id)
            // console.log('res :', res);
            setCodeInfo(res)
        } catch (error) {
            notificationError(error)
        }
    })

    const [accordionBlock, setAccordionBlock] = useState(null)

    const [fetchingProfileMentor, loadingProfileMentor, errorProfileMentor] = useFetching(async (data) => {
        try {

            const mass = []
            const elementFormap = []
            const res = await CheckPointService.getCommandCaseInfo(data)
            res.forEach(element => {
                mass.push(element["id_command"])
            });
            const uniqueMass = [...new Set(mass)];

            uniqueMass.forEach(element => {
                elementFormap.push(res.filter(obj => obj.id_command === element))
            });

            setAccordionBlock(
                elementFormap.map((value, key) => <AcordionForGrade table={value} presentation={value[0]["presentation"]} key={`${value[0]?.id_command
                    }_${key}`} addational_material={value[0]["additional_material"]} caseName={value[0]["title"]} caseCategory={value[0]["category"]} caseSpecification={value[0]["specification"]} caseExpected={value[0]["expected_result"]} />)

            )
        } catch (error) {
            notificationWarning(error)
        }
    })
    // ------------------------------------------------

    const [popUpWindowForChoice, setPopUpWindowForChoice] = useState(false)

    // <div className={classes.with__input__style} style={{ display: "flex", marginBottom: "2vw" }}>
    //                         <div className={classes.text__style}>
    //                             <Tooltip placement="top" trigger={'hover'} overlay={<span style={{ fontSize: "0.7vw", fontFamily: "Roboto" }} className={classes.tooltip__style}>В выпадающем списке представлены <br />все команды для оценивания</span>}>
    //                                 <span>Команда:</span>
    //                             </Tooltip>
    //                         </div>
    //                         <InputBlock readOnly={true} indexStatus={true} onListStatus={true} list={commandList} value={currentCommand} setValue={choiceCommand} refMainContainer={ref}><img src={require("assets/images/arrow.jpg")} /></InputBlock>
    //                     </div>
    return (
        <Loader>
            {popUpWindowForChoice
                ? <TeamChoice setPopUpWindowForChoice={setPopUpWindowForChoice} gradeLength={titlesData.length}
                    value={currentCommand} commandList={commandListPhone} choiceCommand={choiceCommand} />
                : <div ref={ref} className={classes.events__create__style}>
                    <TitleMain text={"Защита работ"} jsc="center" fns="1.5vw" elpSize="0.9vw" />
                    {/* <h3 className={classes.h3__style}>Защита работ</h3> */}
                    {device === "phone"
                        ? <div className={classes.with__input__style} style={{ display: "block", marginBottom: "6vw" }}>
                            {/* ? <div className={classes.with__input__style} style={{ display: "flex" }}> */}
                            <TeamChoiceButton onClick={() => setPopUpWindowForChoice(true)} currentCommand={currentCommand} />
                            {/* <InputBlock readOnly={true} indexStatus={true} placeholder={"Команда"} onListStatus={true} list={commandList} value={currentCommand} setValue={choiceCommand} refMainContainer={ref}><img src={require("assets/images/arrow.jpg")} /></InputBlock> */}
                        </div>
                        : <div className={classes.with__input__style} style={{ display: "flex", marginBottom: "2vw" }}>
                            {/* <div className={classes.text__style}>
                                <Tooltip placement="top" trigger={'hover'} overlay={<span style={{ fontSize: "0.7vw", fontFamily: "Roboto" }} className={classes.tooltip__style}>В выпадающем списке представлены <br />все команды для оценивания</span>}>
                                    <span>Команда:</span>
                                </Tooltip>
                            </div> */}
                            <InputBlock placeholder={"Команда"} readOnly={true} indexStatus={true} onListStatus={true} list={commandList} value={currentCommand} setValue={choiceCommand} refMainContainer={ref}><img src={require("assets/images/arrow.jpg")} /></InputBlock>
                        </div>
                    }

                    <div className={classes.markWork__code_review}>
                        {codeInfo.code_review != null && <span>Оценка кода: {codeInfo.code_review}</span>
                        }

                        {codeInfo.comment != null &&
                            <span>Комментарий к коду: {codeInfo.comment}</span>
                        }
                    </div>
                    {occasion && (currentCommandId && currentCommandId !== -1) && accordionBlock && accordionBlock}
                    {occasion && (currentCommandId && currentCommandId !== -1) && <CheckMarkBlock grades={grades} setGrades={setGrades} mass={JSON.parse(occasion.final_assessment_question)} />}
                    {(currentCommandId && currentCommandId !== -1) &&
                        <div className={classes.repo__and__grade__style}>
                            {device === "phone"
                                ? <div className={classes.repo__style}>
                                    <Description obBlure={createOrUpdateRatingJuryCommand} value={comment} setValue={setComment} placeholder={"Отзыв по работе"} />
                                </div>
                                : <div className={classes.repo__style}>
                                    {/* <div className={classes.text__style}>
                                        <Tooltip placement="top" trigger={'hover'} overlay={<span style={{ fontSize: "0.7vw", fontFamily: "Roboto" }} className={classes.tooltip__style}>Краткое описание мероприятия <br />(что проходит, для кого рассчитано и тд.)</span>}>
                                            <span>Отзыв:</span>
                                        </Tooltip>
                                    </div> */}
                                    <Description placeholder={"Отзыв"} obBlure={createOrUpdateRatingJuryCommand} value={comment} setValue={setComment} />
                                </div>
                            }
                        </div>
                    }
                    {(currentCommandId && currentCommandId !== -1) &&
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "end", marginTop: "2vw" }}>
                            <Button onClick={createOrUpdateRatingJuryCommand}>Сохранить</Button>
                        </div>
                    }


                    {device === 'phone' &&
                        <div className={classes.border__block}>
                            <div className={classes.text__style__table}>
                                {titlesData.length > 0 && titlesData.map((value, i) => <span className={classes.text__name__style} key={i} >{i + 1} - {value}</span>)}
                            </div>
                        </div>
                    }


                    {tableTitle.length > 0 && tableData.length > 0 && <TableForMark tableTitle={tableTitle} tableData={tableData} />}
                    {/* <div className={classes.border__block}>
                    <Table className={classes.table__style} columns={tableTitle} data={tableData} />
                </div> */}
                </div >}
        </Loader >
    )
}
export default FinalMark